<template>
    <v-card>
        <experiment-design-configuration
            :experiment-code="experiment.code"
            :experiment-setup-status="setupStatus"
            :num-of-conditions="numOfConditions"
            :schemaConfig="schemaConfig"
        />
        <experiment-treatments-list
            :experimentCode="experiment.code"
            :treatments="experimentTreatments"
            :experiment-setup-status="setupStatus"
            @treatmentSaved="fetchData"
        />
        <condition-factors
            v-if="experimentTreatments.length > 0"
            :experiment="experiment"
            :treatments="experimentTreatments"
            @conditionsUpdated="handleUpdatedConditions"
        />
        <experiment-relationship-types-list
            :experiment-relationships="experimentRelationships"
        />
    </v-card>
</template>
<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { withLoadingScreen } from "@/lib/loading";
import { experimentRelationshipsAPI } from "@/services/experimentRelationships/experimentRelationshipsAPI";
import { ExperimentRelationshipDTO, ExperimentRelationshipsForType } from "@/services/experimentRelationships/models";
import ExperimentRelationshipTypesList from "@/components/Experiments/ExperimentRelationshipTypesList.vue";
import ExperimentTreatmentsList from "@/components/Treatments/ExperimentTreatmentsList.vue";
import { Treatment, treatmentsAPI } from "@/services/treatments/treatmentsAPI";
import { ExperimentLike, ExperimentSetupStatus } from "@/services/experiments/experimentsAPI";
import ExperimentDesignConfiguration from "@/components/ExperimentDesignConfigs/ExperimentDesignConfiguration.vue";
import ConditionFactors from "@/components/Conditions/ConditionFactors.vue";
import { Condition } from "@/services/things/models";
import { AbstractSchemaConfig } from "@/services/schemas/manageSchemasAPI";

const { experiment, setupStatus, schemaConfig } = defineProps<{
    experiment: ExperimentLike;
    setupStatus: ExperimentSetupStatus
    schemaConfig: AbstractSchemaConfig
}>();


const experimentTreatments = ref<Treatment[]>([]);
const experimentRelationships = ref<ExperimentRelationshipsForType<ExperimentRelationshipDTO>[]>([]);
const conditions = ref<Condition[] | null>(null);

const numOfConditions = computed(() => {
    return conditions.value?.length || null;
});

onMounted(() => {
    fetchData();
});

function handleUpdatedConditions(updatedConditions: Condition[]) {
    conditions.value = updatedConditions;
}

async function fetchData() {
    await withLoadingScreen(async () => {
        experimentRelationships.value = await experimentRelationshipsAPI.fetchForExperimentCode(experiment.code);
        experimentTreatments.value = await treatmentsAPI.fetchTreatmentsForExperimentCode(experiment.code);
    });
}

</script>
